import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, X } from "lucide-react";

const FEATURE_LABEL = {
  ai_diagnose:      "AI Diagnose calls",
  video_uploads:    "video uploads",
  cokeeper_invites: "co-keeper invites",
};

/**
 * Soft modal shown when a Free user hits a usage limit. Pass `open` +
 * `detail` (the 402 response body: { feature, limit, message }) and
 * `onClose`. Calling "Upgrade" navigates to /app/settings.
 */
export default function UpgradeModal({ open, detail, onClose }) {
  const navigate = useNavigate();
  if (!detail) return null;
  const featureLabel = FEATURE_LABEL[detail.feature] || detail.feature;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="upgrade-modal">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 w-7 h-7 rounded-full text-stone-400 hover:text-stone-700 hover:bg-stone-100 grid place-items-center"
          data-testid="upgrade-modal-close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="text-center pt-2">
          <div className="w-14 h-14 rounded-full bg-amber-100 grid place-items-center mx-auto mb-3 ring-4 ring-amber-50">
            <Sparkles className="w-7 h-7 text-amber-600" />
          </div>
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-bold leading-snug">
              You've hit this month's {featureLabel} limit
            </DialogTitle>
            <DialogDescription className="text-stone-600 mt-2">
              Free plan gets {detail.limit} per month. Upgrade to Pro for unlimited {featureLabel} and remove every cap.
            </DialogDescription>
          </DialogHeader>
          <Button
            onClick={() => { onClose(); navigate("/app/settings?tab=billing"); }}
            className="rounded-full bg-amber-500 hover:bg-amber-400 text-stone-950 font-bold mt-5 px-6 h-11 shadow-[0_0_24px_rgba(245,158,11,0.4)]"
            data-testid="upgrade-modal-cta"
          >
            See Pro plans
          </Button>
          <button
            onClick={onClose}
            className="block mx-auto mt-2 text-xs text-stone-500 hover:text-stone-800 transition-colors"
            data-testid="upgrade-modal-dismiss"
          >
            Maybe later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
